import { Component, ElementRef, HostListener, EventEmitter, Input, Output, OnInit, QueryList, ChangeDetectionStrategy, SimpleChanges, ViewChild, ViewChildren, AfterViewInit } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import * as projectsetup from '../../../../../projectmanagement/src/app/forms/projectmanagement.form';

import { SchoolManagementService } from '../../service/schoolmanagement.service';

import { MyErrorHandler } from '../../../../../tools/src/lib/errorhandler/errorhandler';

import { Grade, Year, Class, Subject } from '../../model/school.model';
import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { TranslateService } from '@ngx-translate/core';

import * as _ from 'underscore';
// import { ComponentStillLoadingError } from '@angular/compiler/src/private_import_core';
import {Dialog} from '@eds/vanilla';
declare var jQuery;

@Component({
  selector: 'app-ctl-sch-classsubject-form',
  templateUrl: './ctl.school.classsubject.component.html',
  styleUrls: ['./ctl.school.classsubject.component.css'],
  providers: [SchoolManagementService]
})


export class SchoolClassSubjectComponent implements OnInit {

  @Input() viewType: string;
  @Input() data: any;
  @Input() schoolName:string;
  @Input() myForm: FormGroup;
  @Input() mySubjectsList = [];
  @ViewChildren('inputClass') rows: QueryList<any>;
  private sub1:Subscription = new Subscription();
  // @Input() mySelectedClass: string;
  mySelectedSubjectsList = [];
  loggedInUser: any;
  selectedClass;
  newclasslist = [];
  ldata: any = [];
  isSubjectRemoved:boolean = false;
  inputfocus: string = '';
  blankItemIndex = 0;
  titleMessage = '';
  detailMessage1 = '';
  detailMessage2 = '';
  removeItemIndex = '';
  removedClassArr=[];
  row = [];
  textDir:any;
  @Output() evRemoveSubject: EventEmitter<any> = new EventEmitter();
  @Output() evAddSubject: EventEmitter<any> = new EventEmitter();
  @Output() evEditEnable: EventEmitter<boolean> = new EventEmitter();
  @Output() evRemoveClass: EventEmitter<any> = new EventEmitter();
  @Output() evAddClass: EventEmitter<any> = new EventEmitter();
  constructor(
    private _fb: FormBuilder,
    private schoolService: SchoolManagementService,
    private router: Router,
    private translate:TranslateService,
    private route: ActivatedRoute) {
      this.textDir = sessionStorage.getItem('textDir')
  }

  ngOnInit() {
    // jQuery('[data-toggle="tooltip"]').tooltip();

    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    if (userData) {
      this.loggedInUser = userData;
    }    
  }

  ngAfterViewInit() {
      //
      this.sub1 = this.rows.changes.subscribe(resp => {
        if (this.rows.length > 1){
          setTimeout(() => {
            this.rows.last.nativeElement.focus();
         }, 0)
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    //
    console.log('On Changes');
    if (typeof changes['mySubjectsList'] !== "undefined") {
      var change = changes['mySubjectsList'];
      if (!change.isFirstChange()) {
        if(this.data){
          this.ldata={...this.data};      
          this.addClassesToForm(this.data);
         
          let subControl = <FormArray>this.myForm.controls['subjects'];
          subControl.patchValue(this.data.objsubjects);
          this.mySelectedSubjectsList = this.data.objsubjects;
        }
      }
    }
  }



  ngDoCheck() {
    //
    if(this.data && !_.isEqual(this.data, this.ldata)){
      console.log('DO CHeck');
      this.ldata={...this.data};      
      this.addClassesToForm(this.data);
      console.log("this.data jani >>> "+JSON.stringify(this.data))
      let subControl = <FormArray>this.myForm.controls['subjects'];
      subControl.patchValue(this.data.objsubjects);
      this.mySelectedSubjectsList = this.data.objsubjects;
    }
  }


  addClassesToForm(data){
    this.myForm.removeControl('classes');
    this.myForm.addControl('classes', this._fb.array([]));
    let clControl = <FormArray> this.myForm.controls['classes'];
    if(data.objclasses){
      data.objclasses.forEach(item => {  
        if(item.name !== null){
          clControl.push(this.patchClasses(item.name,item._id));
        }             
      });
      for(let i=0; i < clControl.length; i++){
        let classDataArr = clControl.at(i);
        if(classDataArr.value.name !== ""){
          this.row[i] = true;
        }
      }
      this.generateBlankItemIndex();
    } 
    console.log(clControl);
  }


  isChecked(data) {
    if (this.mySelectedSubjectsList && this.mySelectedSubjectsList.findIndex(x=> x._id === data._id) !== -1) {
      return true;
    } else {
      return false;
    }
  }
  log(data){
    console.log(data);
  }
  checkUncheckSubject(data, event) {
    //alert(JSON.stringify(data))
    this.isSubjectRemoved = event.target.checked;
    if(event.target.checked){     
      if(this.mySelectedSubjectsList && this.mySelectedSubjectsList.indexOf(data.name) === -1){
        this.mySelectedSubjectsList.push(data);
      } 
      else if(this.mySelectedSubjectsList == undefined ){
        this.mySelectedSubjectsList=[];
        this.mySelectedSubjectsList.push(data);
        let subControl = <FormArray>this.myForm.controls['subjects']; //need to be fixed later if class is not mapped to grade
        subControl.patchValue(this.mySelectedSubjectsList);
      }    
    }else{
      if(this.mySelectedSubjectsList && this.mySelectedSubjectsList.length && this.mySelectedSubjectsList.findIndex(x=> x.name === data.name) !== -1){
        this.mySelectedSubjectsList.splice(this.mySelectedSubjectsList.findIndex(x=> x._id === data._id), 1);
      }  
      this.removeSubject(data);  
    }      
  }

  edit() {
    //
    this.evEditEnable.emit(true);
  }

  addNewClass(i) {    
    let control = <FormArray>this.myForm.controls['classes'];
    control.push(this.patchClasses(''));
    this.generateBlankItemIndex();
    this.row[i] = true;
    this.evAddClass.emit(i);
  }

  removeClassConfirm(i){
    this.removeItemIndex = i;
    this.titleMessage = this.translate.instant('Remove Class(es)?');
    this.detailMessage1 =this.translate.instant('You have chosen to remove one or more Classes from your School. Any assigned Students will automatically become archived. Re-assignment and re-activation must be completed manually.');
    this.detailMessage2 = this.translate.instant('Select OK to confirm.');
    //this.openDialogModal('errorModal');
    // jQuery('#errorModal').modal('show');
    // this.row[i] = false;
    // this.myForm.controls['classes']['controls'][i].patchValue({name:'',_id:''}); 
    this.generateBlankItemIndex();
  }


  removeClass(i, clsId?){
    
    this.row[i] = false;    
    this.myForm.controls['classes']['controls'][i].patchValue({name:'',_id:''}); 
    this.generateBlankItemIndex(null,'remove');   
    this.evRemoveClass.emit(clsId);
  }

  removeSubject(subjId?){
   // alert("remoed >>"+this.isSubjectRemoved);    
    //this.generateBlankItemIndex(null,'remove');
    this.evRemoveSubject.emit({id: subjId._id, name: subjId.name,removed:this.isSubjectRemoved});
  }
  
  generateBlankItemIndex(txt?,action?){
    let frmControl = <FormArray>this.myForm.controls['classes'];
    for(let i=0; i < frmControl.length; i++){
      let classDataArr = frmControl.at(i);
      if(classDataArr.value.name == "" && !txt){
        this.blankItemIndex = i;
        return;
      }else{
        this.blankItemIndex = i+1;
      }
    }    
  }

  patchClasses(n?, i?) {
    return this._fb.group({
      name: n,
      _id: i || ''
    });
  }

  // patchSubject(_id, name, project_id) {
  //   return this._fb.group({
  //     _id: [_id],
  //     name: [name],
  //     project_id: [project_id]
  //   });
  // }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bodyBG');
    //this.sub1.unsubscribe();
  }

  trackByFn(index:any, item:any){
    return index;
  }
  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }
  
}
